export enum ModelPreference {
  MEDIUM = 'medium',
  HIGH = 'high',
}

interface IModelSelectorProps {
  model: ModelPreference;
  onChange: (model: ModelPreference) => void;
  disabled?: boolean;
  options: {
    value: ModelPreference;
    label: string;
    description: string;
    badge?: string;
    /**
     * This deployment's LLM cannot serve the tier. The option stays in the
     * list, muted and unselectable, rather than disappearing: a tier that
     * vanishes reads as a bug, where a greyed one with a reason reads as a
     * fact about the configuration.
     */
    unavailable?: boolean;
    /** Why it cannot be chosen, shown under the label when muted. */
    unavailableReason?: string;
  }[];
}

export type { IModelSelectorProps };